import { ReportingState } from '@deltager/organizers/admin/modules/reporting/reporting-main/store/reporting.state';
import { Action } from '@ngrx/store';
import {
  TransactionFiltersChangedAction,
  TransactionLoadingChangedAction,
  ReportingActionTypes,
  SettlementFiltersChangedAction,
  SettlementLoadingChangedAction,
} from '@deltager/organizers/admin/modules/reporting/reporting-main/store/reporting.actions';

export const reportingReducer = (state: ReportingState = {} as ReportingState, action: Action): ReportingState => {
  switch (action.type) {
    case ReportingActionTypes.TransactionFiltersChanged: {
      return Object.assign({}, state, {
        transactionFilters: (action as TransactionFiltersChangedAction).payload,
      } as ReportingState);
    }
    case ReportingActionTypes.TransactionLoadingChanged: {
      return Object.assign({}, state, {
        isLoadingTransactionsTable: (action as TransactionLoadingChangedAction).payload,
      } as ReportingState);
    }
    case ReportingActionTypes.SettlementFiltersChanged: {
      return Object.assign({}, state, {
        settlementFilters: (action as SettlementFiltersChangedAction).payload,
      } as ReportingState);
    }
    case ReportingActionTypes.SettlementLoadingChanged: {
      return Object.assign({}, state, {
        isLoadingSettlementTable: (action as SettlementLoadingChangedAction).payload,
      } as ReportingState);
    }
    default:
      return state;
  }
};
